"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createComponentTimeout = void 0;
function createComponentTimeout(cb, time) {
    let timeout;
    const reset = (reason) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            cb();
        }, time);
    };
    const resetFromEl = (event) => reset({
        type: 'DOMEvent',
        event,
    });
    const watching = [];
    const observe = (el, events = ['click', 'touchstart', 'keydown', 'play']) => {
        watching.push({ el, events });
        for (const eventName of events) {
            el.addEventListener(eventName, resetFromEl);
        }
    };
    const destroy = () => {
        clearTimeout(timeout);
        watching.forEach(({ el, events }) => {
            for (const event of events) {
                el.removeEventListener(event, resetFromEl);
            }
        });
    };
    const componentTimeout = {
        reset: (reason) => {
            reset({ type: 'manual', reason });
            return componentTimeout;
        },
        destroy: () => {
            destroy();
            return componentTimeout;
        },
        observe: (el, events) => {
            observe(el, events);
            return componentTimeout;
        },
    };
    return componentTimeout;
}
exports.createComponentTimeout = createComponentTimeout;
